{
  "de": {
    "employee": {
      "actions": {
        "accessProjects": "Projektzugriff verwalten",
        "cancel": "Rückgängig machen",
        "changeProfilePicture": "Profilbild ändern",
        "download": "Herunterladen",
        "new": "Teammitglied",
        "profilePictureFormat": "Sollte mindestens 300×300 px sein",
        "save": "Speichern",
        "searchEmployee": "Teammitglied suchen",
        "sendinvitation": "Einladung erstellen und senden",
        "submit": "Speichern",
        "undoChanges": "Rückgängig machen"
      },
      "attributes": {
        "email_address": "E-Mail",
        "email_notifications_interval": {
          "daily": "Einmal täglich (gegen Mittag)",
          "hourly": "Stündlich",
          "twice_daily": "Zweimal täglich (Morgen/Mittag)",
          "weekly": "Einmal wöchentlich (montags mittags)"
        },
        "first_name": "Vorname",
        "language": "Sprache",
        "last_name": "Nachname",
        "phone_landline": "Festnetznummer",
        "phone_mobile": "Mobilnummer",
        "profession": "Position",
        "role": "Zugriffsrechte",
        "signature_html": "Konversationssignatur",
        "status": "Status",
        "title": "Anrede"
      },
      "billing": {
        "contact_us": "Kontaktieren Sie uns",
        "contact_us_message": "Hallo, ich möchte das Paket von {client_name} ändern.",
        "gigabytes": "{amount} GB",
        "in_use": "/ {total} in Nutzung",
        "manage_members": "Mitglieder verwalten",
        "package": "Paket",
        "package_help_mup": "Sie brauchen zusätzliche Projekte oder Speicher oder möchten den Plan wechseln?",
        "package_help_sup": "Sie brauchen zusätzliche Projekte, Plätze oder Speicher oder möchten den Plan wechseln?",
        "plan_renamed": "Wir haben neue Pläne eingeführt, daher stimmt der hier angezeigte Name möglicherweise nicht mit Ihrem aktuellen Abonnement überein. Kontaktieren Sie uns, um mehr über die neuen Pläne zu erfahren.",
        "projects": "Projekte",
        "projects_available": "Alle Projekte in Nutzung | 1 Projekt verfügbar | {count} Projekte verfügbar",
        "seats": "Plätze",
        "seats_active": "/ {total} aktiv",
        "seats_package": "Keine Plätze in Ihrem Paket | 1 Platz in Ihrem Paket | {count} Plätze in Ihrem Paket",
        "seats_paying": "+ 1 zusätzlicher bezahlter Platz | + {count} zusätzliche bezahlte Plätze",
        "storage": "Speicher",
        "storage_available": "{amount} GB verfügbar",
        "storage_total": "/ {amount} GB",
        "units": "Einheiten",
        "units_available": "Alle Einheiten in Nutzung | 1 Einheit verfügbar | {count} Einheiten verfügbar"
      },
      "integrations": {
        "hide_details": "Details ausblenden",
        "last_synced_at": "Zuletzt synchronisiert am: {time}",
        "show_details": "Details anzeigen"
      },
      "labels": {
        "all_projects": "Alle Projekte",
        "confirmPasswordReset": "Eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts wurde gesendet. Bitte prüfen Sie Ihren Posteingang. Kontaktieren Sie uns, falls Probleme auftreten.",
        "disabled": {
          "access": "Wir gewähren allen Mitarbeitern Zugriff auf die Plattform, sobald die letzte überfällige Rechnung bezahlt wurde.",
          "contact": "Kontaktieren Sie uns",
          "overdue": "Wir haben festgestellt, dass Ihre letzte Rechnung seit Langem überfällig ist. Wir haben den Zugriff für alle Mitarbeiter auf dieser Plattform gesperrt. Partner und Kunden können weiterhin auf ihre Daten zugreifen.",
          "title": "Ihr Konto wurde deaktiviert!"
        },
        "display": "Anzeigen",
        "filters": "Filter",
        "generalNotifications": "Benachrichtigen Sie mich über",
        "has_access_to": "Hat Zugriff auf",
        "information": "Profilinformationen",
        "informationNotificationsEmail": "Erhalten Sie eine Übersicht per E-Mail, die nur Benachrichtigungen enthält, die Sie auf der Plattform noch nicht gesehen haben.",
        "informationNotificationsPlatform": "Erhalten Sie alle Benachrichtigungen in Ihrer persönlichen Übersicht oben rechts auf dem Bildschirm",
        "informationNotificationsTitle": "Entscheiden Sie, welche Art von Benachrichtigungen Sie erhalten möchten und wie",
        "its_you!": "Das sind Sie!",
        "maintainerAccess": "Zugriff pro Projekt.",
        "name": "Name",
        "onPlatform": "Auf der Plattform",
        "ownerAccess": "Zugriff auf alle Projekte und Inhalte, dazu Abrechnung und Teamverwaltung.",
        "password": "Passwort",
        "permissions": "Zugriffsrechte für",
        "permissionsOwnerOnly": "Als Projektbetreuer können Sie diese Aktion nicht durchführen. Bitten Sie ein Teammitglied von {client_name} mit der Rolle Inhaber, dies für Sie zu erledigen.",
        "projectMaintains": "{first_name} hat Zugriff auf die folgenden Projekte:",
        "projectMaintainsAdd": "Um Zugriff zu gewähren, wählen Sie ein Projekt aus und fügen Sie {first_name} unter „Informationen“ als Projektbetreuer hinzu.",
        "projectMaintainsNone": "hat keinen Zugriff auf Projekte.",
        "projectNotifications": "Für Projekt",
        "search_by_name_or_email": "Nach Name oder E-Mail suchen",
        "show_signature": "Signatur anzeigen",
        "signature_active": "Signatur aktiv",
        "signature_info": "Diese Signatur wird Antworten hinzugefügt, die an Kunden und Partner gesendet werden.",
        "sorting": "Sortierung",
        "viaEmail": "Per E-Mail"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Zugänglich",
          "description": "Änderungen werden automatisch gespeichert",
          "not_accessible": "Nicht zugänglich",
          "title": "Projektzugänglichkeit für {first_name} {last_name} aktualisieren"
        }
      },
      "roles": {
        "maintainer": "Projektbetreuer",
        "owner": "Inhaber"
      },
      "team": {
        "actions": {
          "activate": "Aktivieren",
          "cancel_invitation": "Einladung zurückziehen",
          "deactivate": "Deaktivieren",
          "invite": "Einladen",
          "make_maintainer": "Zum Projektbetreuer machen",
          "make_owner": "Zum Inhaber machen",
          "remove": "Aus dem Team entfernen"
        },
        "dialogs": {
          "activate_body": "{name} erhält wieder vollen Zugriff auf die Plattform.",
          "activate_body_pending": "{name} wird wieder auf Ausstehend gesetzt und wird aktiv, sobald die Anmeldung mit der Einladung erfolgt.",
          "activate_body_seat": "{name} erhält wieder vollen Zugriff auf die Plattform. Das nutzt einen Platz.",
          "activate_confirm": "Aktivieren",
          "activate_title": "{name} aktivieren?",
          "cancel_invitation_body": "{name} kann mit der erhaltenen Einladung nicht mehr beitreten.",
          "cancel_invitation_confirm": "Einladung zurückziehen",
          "cancel_invitation_title": "Einladung zurückziehen?",
          "contact_us": "Kontaktieren Sie uns",
          "contact_us_message": "Hallo, ich möchte weitere Plätze für {client_name} hinzufügen.",
          "deactivate_body": "{name} behält das Konto, verliert aber den Zugriff auf die Plattform.",
          "deactivate_body_seat": "{name} behält das Konto, verliert aber den Zugriff auf die Plattform. Das gibt einen Platz frei.",
          "deactivate_confirm": "Deaktivieren",
          "deactivate_title": "{name} deaktivieren?",
          "demote_body": "{name} verliert den Zugriff auf alle Projekte, bis Sie ihn freigeben, und kann Abrechnung und Team nicht mehr verwalten.",
          "demote_confirm": "Zum Projektbetreuer machen",
          "demote_title": "{name} zum Projektbetreuer machen?",
          "owner_wall_banner": "Ihre Organisation braucht immer mindestens einen aktiven Inhaber.",
          "owner_wall_body_deactivate": "Aktivieren oder befördern Sie einen anderen Inhaber, bevor Sie {name} deaktivieren.",
          "owner_wall_body_demote": "Aktivieren oder befördern Sie einen anderen Inhaber, bevor Sie die Rolle von {name} ändern.",
          "owner_wall_body_remove": "Aktivieren oder befördern Sie einen anderen Inhaber, bevor Sie {name} entfernen.",
          "owner_wall_title": "Aktion blockiert",
          "promote_body": "{name} erhält Zugriff auf alle Projekte und kann Abrechnung und Team verwalten.",
          "promote_confirm": "Zum Inhaber machen",
          "promote_title": "{name} zum Inhaber machen?",
          "remove_body": "{name} verliert den Zugriff und verschwindet aus der Mitgliederliste. Das lässt sich nicht rückgängig machen, aber Sie können später erneut einladen.",
          "remove_body_seat": "{name} verliert den Zugriff und verschwindet aus der Mitgliederliste. Das lässt sich nicht rückgängig machen, aber Sie können später erneut einladen. Das gibt einen Platz frei.",
          "remove_confirm": "Entfernen",
          "remove_title": "{name} aus dem Team entfernen?",
          "seats_full_banner": "Ihr einziger Platz ist belegt. | Alle {total} Plätze sind belegt.",
          "seats_full_body": "Deaktivieren Sie ein aktives Mitglied, um einen Platz freizugeben, oder kontaktieren Sie uns für weitere Plätze.",
          "seats_full_invite_body": "Sie brauchen einen freien Platz, um jemanden einzuladen. Deaktivieren Sie ein aktives Mitglied oder kontaktieren Sie uns für weitere Plätze.",
          "seats_full_invite_title": "Keine Plätze mehr frei",
          "seats_full_title": "Keine Plätze frei"
        },
        "invite_incomplete": "Füllen Sie Vorname, Nachname und E-Mail aus, um die Einladung zu senden.",
        "invite_note": "Sie werden aktiv, sobald sie ein Konto erstellen und sich anmelden.",
        "invite_note_seats": "Sobald sie ein Konto erstellen und sich anmelden, werden sie aktiv und nutzen Ihren letzten freien Platz. | Sobald sie ein Konto erstellen und sich anmelden, werden sie aktiv und nutzen einen Ihrer {count} freien Plätze.",
        "invite_sent": "Einladung gesendet",
        "invited_at": "Eingeladen: {when}",
        "last_active": "Zuletzt aktiv",
        "manage_in_billing": "In Abrechnung verwalten",
        "resend_wait": "Sie können die Einladung 15 Minuten nach der letzten erneut senden.",
        "role": "Rolle",
        "seat_states": "Platzstatus",
        "seat_states_help": {
          "active": "Voller Zugriff, nutzt einen Platz. Inhaber und Projektbetreuer.",
          "inactive": "Konto besteht, kein Zugriff auf die Plattform. Gibt den Platz frei.",
          "pending": "Eingeladen, noch kein Konto. Nutzt keinen Platz."
        },
        "seat_usage": "Platznutzung",
        "seats_available": "Keine Plätze frei — deaktivieren Sie ein Mitglied oder kontaktieren Sie uns | 1 Platz frei | {count} Plätze frei",
        "seats_rule": "Nur ein Inhaber kann ein Mitglied aktivieren, und nur solange ein Platz frei ist.",
        "seats_total": "/ {total} aktiver Platz | / {total} aktive Plätze",
        "statuses": {
          "active": "Aktiv",
          "inactive": "Inaktiv",
          "pending": "Ausstehend"
        }
      },
      "toasts": {
        "create": "Teammitglied wurde erstellt",
        "update": "Teammitglied wurde aktualisiert"
      },
      "validation": {
        "emailTaken": "E-Mail-Adresse wurde bereits verwendet",
        "mustBeEmailAddress": "Gültige E-Mail-Adresse erforderlich",
        "needFirstName": "Vorname erforderlich",
        "needLastName": "Nachname erforderlich",
        "requireEmailAddress": "E-Mail-Adresse erforderlich",
        "role": "Zugriffsrechte auswählen"
      }
    }
  }
}
